import React from 'react';
import Box from '@sizeid/commons/components/Box';
import Text from '@sizeid/commons/components/Text';
import Checkbox from '@sizeid/commons/components/Checkbox';
import { TFunction } from 'next-i18next';

import {
  TYPE_BLOG,
  TYPE_INTERNET,
  TYPE_PARTNERS,
  TYPE_PRINT,
} from '../constants';
import { ArticleType } from '../types';

import PressCheckboxesWrap from './styled/PressCheckboxesWrap';

const KEYS = [TYPE_INTERNET, TYPE_PARTNERS, TYPE_BLOG, TYPE_PRINT];

const PressCheckboxes: React.FC<{
  state: Record<string, boolean>;
  onChange: (key: ArticleType) => void;
  t: TFunction;
}> = ({ state, onChange, t }) => (
  <PressCheckboxesWrap>
    {KEYS.map(key => (
      <Box
        row
        align
        key={key}
        cursor="pointer"
        flex="0 0 252px"
        marginLeft={2}
        marginTop={2}
      >
        <Checkbox big checked={state[key]} onChange={() => onChange(key)} />
        <Box width="200px" marginLeft={1} css="text-align: left;">
          <Text white size={8} onClick={() => onChange(key)}>
            {t(`press.types.${key}`)}
          </Text>
        </Box>
      </Box>
    ))}
  </PressCheckboxesWrap>
);

export default PressCheckboxes;
